import React, { useState, useMemo, useEffect } from 'react';
import { Box, Typography, Grid, Button, Stack } from '@mui/material';
import { useTheme } from "@mui/material";
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { useLoginReq } from "../Login/Hooks/index";
import CircularProgress from '@mui/material/CircularProgress';
import * as Yup from "yup";
import Logo from "../../asset/imgs/Bimags/logomain.png";
import { Form, Formik } from "formik";
import FormikControl from "../../Components/Formik/FormikControl/FormikControl";
import TextFieldIcon from '../../Components/Formik/FormikControl/TextFieldIcon/TextFieldIcon';
import SearchIcon from '@mui/icons-material/Search';
import LockIcon from '@mui/icons-material/Lock';
import PrimaryButton from "../../General/Components/PrimaryButton/PrimaryButton";
import { motion, AnimatePresence } from "framer-motion";
import ToastMessage from "../../scenes/global/ToastMessage/ToastMessage";
import useToast from "../../utils/ToastHook";
import Banner from './Components/NoticeLogin/Banner';
import { useMediaQuery } from "@mui/material";
import { LoginLangSwitcher } from './Components/LoginLangSwitcher/LoginLangSwitcher'
import { useTranslation } from 'react-i18next';



import Captcha from './Components/Captcha/Captcha';
import {
  containerVariants, fadeInVariants, logoPulseVariants, fadeInVariants2, validationSchema,
  initialLoginBody, formContainerStyle, brandingContainerStyel, primeryButtunStyle,
  formMainTitleStyle,
  fadeInVariants3
} from './Statics/index';
import { tokens } from '../../theme';


const Login = () => {
  const { i18n } = useTranslation();
  const { t, ready } = useTranslation('authentication');
  if (!ready) return null;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isMobile = useMediaQuery('(max-width:600px)');
  const [showBrand, setShowBrand] = useState(true);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const { colorToast, handleFailed, handleSuccess, openToast, toastText, closeToast } = useToast({
    afterClose: () => { },
  });
  const [moduleState, setModuleState] = useState({
    toast: false,
    serverMessage: ''
  })
  const [rememberState, setRememberState] = useState({
    'rememberMe': true, 'updateLogInCount': false
  })

  useEffect(() => {
    localStorage.setItem('rasamAplicationMod', 'light');
  }, [])

  const handleFailedLoginRequest = (err) => {
    setModuleState({ toast: true, serverMessage: err });
  };


  const { mutateAsync: loginRequest, isLoading: isLogining, isSuccess, data: LoginData } = useLoginReq(() => {

  }, handleFailedLoginRequest);

  const handleLogin = (data) => {
    loginRequest({ ...data, ...rememberState })
  }

  useEffect(() => {

    if (isSuccess && LoginData?.data?.data?.needCaptcha) {
      let { data: { statusCode, data: { needCaptcha } } } = LoginData;
      if (needCaptcha && statusCode === 200) {
        setShowCaptcha(true)
      }
    }

  }, [LoginData])

  useEffect(() => {
    if (!isMobile) {
      setShowLogin(true);
      return;
    }

    const timer = setTimeout(() => {
      setShowBrand(false);

      setTimeout(() => {
        setShowLogin(true);
      }, 600); // بعد از fadeOut بنر
    }, 5000);

    return () => clearTimeout(timer);
  }, [isMobile]);


  const validationSchemaMemoized = useMemo(() => validationSchema, []);

  const handleShowBannerAgain = () => {
    setShowBrand(true);

    setTimeout(() => {
      setShowLogin(false);
    }, 150);

    setTimeout(() => {
      setShowBrand(false);

      setTimeout(() => {
        setShowLogin(true);
      }, 500);
    }, 7000);
  };

  localStorage.removeItem("claims")

  return (
    <>
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
          position: 'relative',
          background: `
                  linear-gradient(
                  -45deg,
                  #082021,
                  #0F3D3F,
                  #135052,
                  #19686A,
                  #208588,
                  #4FA8AA
                  )
                  `,
          backgroundSize: '400% 400%',
          animation: 'gradientMove 15s ease infinite',

          '@keyframes gradientMove': {
            '0%': {
              backgroundPosition: '0% 50%',
            },
            '50%': {
              backgroundPosition: '100% 50%',
            },
            '100%': {
              backgroundPosition: '0% 50%',
            },
          },
        }}
      >

        <Box
          sx={{
            width: {
              xs: '95%',
              md: '1100px',
            },
            minHeight: '650px',

            display: 'flex',
            flexDirection: {
              xs: 'column',
              md: 'row',
            },

            borderRadius: '30px',
            overflow: 'hidden',

            backdropFilter: 'blur(20px)',

            background: 'rgba(255,255,255,0.08)',

            border: '1px solid rgba(255,255,255,0.15)',

            boxShadow:
              '0 25px 60px rgba(0,0,0,.35)',
            p: 1
          }}
        >
          {/* بخش معرفی برند */}
          <AnimatePresence mode="wait">
            {(showBrand || !isMobile) && (
              <motion.div
                key="banner"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{
                  opacity: 0,
                  scale: 0.96,
                  filter: 'blur(8px)',
                }}
                style={{
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  marginBottom: isMobile ? '50px' : 0,
                }}
              >
                <Banner />
              </motion.div>
            )}
          </AnimatePresence>
          {/* بخش فرم ورود */}


          {
            !showCaptcha ? <AnimatePresence mode="wait">
              {showLogin && (
                <motion.div
                  key="login"
                  initial={{
                    opacity: 0,
                    y: 30,
                    scale: 0.96,
                  }}
                  animate={{ opacity: 1, y: 0, scale: 1 }}
                  exit={{ opacity: 0, y: -10, scale: 0.98 }}
                  transition={{ duration: 0.6, ease: "easeOut" }}
                  style={{
                    flex: 1,
                    width: '100%',
                  }}
                >
                  <Box
                    sx={{
                      flex: 1,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Formik
                      initialValues={initialLoginBody}
                      validationSchema={validationSchemaMemoized}
                      onSubmit={(data) => handleLogin(data)}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        isValid,
                        dirty,
                      }) => (
                        <Form style={{ width: '100%' }}>

                          <Grid
                            container
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              px: 1,
                            }}
                          >

                            <Grid
                              item
                              xs={12}

                              sx={{
                                bgcolor: '#ffffff',
                                boxShadow: { xs: 2, sm: 4 },
                                borderRadius: { xs: 2, sm: 5 },
                                py: { xs: 4, sm: 5 },
                                px: { xs: 3, sm: 5 },
                                rowGap: 3,
                                mx: 'auto',
                                transition: 'all 0.3s ease',
                                gap: 5

                              }}
                            >
                              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: 1 }}>
                                {/* عنوان فرم */}
                                <Box sx={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
                                  <LoginLangSwitcher />
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}   >
                                  <Box>
                                    <motion.img
                                      src={Logo}
                                      alt="logo"
                                      style={{
                                        width: isMobile ? '90%' : '90%',
                                        height: isMobile ? '90%' : '90%',
                                        borderRadius: '10%',
                                        originX: 0.5, // مرکز چرخش/مقیاس
                                        originY: 0.5,
                                      }}
                                      variants={fadeInVariants} // انیمیشن ورود اولیه
                                      initial="hidden"
                                      whileInView="visible" // وقتی در دید قرار گرفت، انیمیشن ورود اجرا بشه
                                      whileHover="pulsing" // انیمیشن "خودنمایی" در حالت هاور (می‌تواند تغییر کند)


                                    />
                                  </Box>

                                </Box>





                                <Typography
                                  sx={{
                                    ...formMainTitleStyle,
                                    bgcolor: colors.primary[400],
                                    width: '100%'
                                    // pb:{xs:0,sm:8}
                                  }}
                                >

                                  {
                                    t('login.enterInfo')
                                  }
                                </Typography>

                                {/* فیلد نام کاربری */}
                                <TextFieldIcon
                                  mainLabel={
                                    t('login.username')
                                  }
                                  name="username"
                                  label={
                                    t('login.username')
                                  }
                                  icon={PersonOutlineOutlinedIcon}
                                  type="text"
                                  formik
                                  sx={{ mb: { xs: 2, sm: 3 } }}
                                />

                                {/* فیلد رمز عبور */}
                                <TextFieldIcon
                                  mainLabel={
                                    t('login.password')
                                  }
                                  name="password"
                                  label={t('login.password')}
                                  type="password"
                                  icon={LockIcon}
                                  formik
                                  sx={{ mb: { xs: 2, sm: 3 } }}
                                />

                                {/* چک‌باکس "مرا به خاطر بسپار" */}
                                <FormikControl
                                  name='preInvoice'
                                  control='singlcheckbox'
                                  label={t('login.rememberme')}
                                  type='boolean'
                                  value={values.preInvoice || false}
                                  sx={{ mb: { xs: 3, sm: 4 } }}
                                />

                                <PrimaryButton
                                  type='submit'
                                  sx={{
                                    ...primeryButtunStyle,
                                    backgroundColor: colors.primary[600],

                                  }}
                                  label={!isSuccess && isLogining ? t('login.processing') : t('login.enter')}
                                  disabled={!isValid || !dirty || isLogining}
                                  endIcon={isLogining ? (
                                    <CircularProgress color='success' size={18} />
                                  ) : (
                                    <></>
                                  )}
                                />
                              </Box>
                            </Grid>

                            {/* جمله پایین صفحه */}
                            <Grid item xs={12}>

                              <motion.div variants={fadeInVariants2} initial="hidden" whileInView="visible">
                                <Typography
                                  variant='body1'
                                  sx={{
                                    color: 'white',
                                    textAlign: 'center',
                                    mt: 2,
                                    mx: 'auto',
                                    fontWeight: 600,
                                    textShadow: '0 2px 8px rgba(0,0,0,0.3)' // کمی سایه برای خوانایی بهتر روی گرادیان
                                  }}
                                >

                                  {
                                    t('login.slogan')
                                  }
                                </Typography>


                              </motion.div>

                              {isMobile && !showBrand && (
                                // <motion.div variants={fadeInVariants3} initial="hidden" whileInView="visible">

                                <Typography
                                  onClick={handleShowBannerAgain}
                                  sx={{
                                    mt: 2,
                                    textAlign: 'center',
                                    color: 'blue',
                                    cursor: 'pointer',
                                    fontSize: '0.9rem',
                                    transition: 'all .3s',

                                    '&:hover': {
                                      opacity: 0.8,
                                      color: 'lightblue',
                                      // textDecoration: 'underline',
                                      textShadow: '0 2px 8px rgba(0,0,0,0.3)',
                                      // textDecoration: 'underline',
                                    },
                                  }}
                                >

                                  {
                                    t('login.announcement')
                                  }

                                </Typography>
                                // </motion.div>

                              )}

                            </Grid>
                          </Grid>
                        </Form>
                      )}
                    </Formik>
                  </Box>
                </motion.div>
              )}
            </AnimatePresence>
              :

              <Captcha
                setShowCaptcha={setShowCaptcha}
                setRememberState={setRememberState}
              />
          }
        </Box>



      </Box>

      {
        moduleState?.toast && <ToastMessage
          show={moduleState?.toast}
          remove={setModuleState}
          // opPerform={toast?.asyncOperation}
          global={true}
          customText={moduleState?.serverMessage} />
      }
    </>
  )
}

export default Login